<template>
  <div id="card">
    <v-card>
      <v-card-title><h2>LO Information</h2></v-card-title>
      <br />
      <v-card-text>
        <v-row wrap>
          <v-col cols="12" lg="4" md="4" sm="6" class="mb-4">
            <v-card class="mt-4 mx-auto" max-width="400">
              <v-sheet
                class="v-sheet--offset mx-auto"
                color="cyan"
                elevation="3"
                max-width="calc(100% - 62px)"
              >
                <v-row>
                  <v-col cols="12">
                    <h4 class="ml-4">Location Details</h4>
                  </v-col>
                </v-row>
              </v-sheet>
              <v-card-text class="pt-0">
                <location-information-list></location-information-list>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="8" md="8" sm="6"  class="mb-4">
            <v-card class="mt-4 mx-auto">
              <v-sheet
                class="v-sheet--offset mx-auto"
                color="cyan"
                elevation="3"
                max-width="calc(100% - 62px)"
              >
                <v-row>
                  <v-col cols="12">
                    <h4 class="ml-4">Bank Details</h4>
                  </v-col>
                </v-row>
              </v-sheet>
              <v-card-text>
                <bank-information-list></bank-information-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="4" md="4" sm="6">
            <v-card class="mt-4 mx-auto">
              <v-sheet
                class="v-sheet--offset mx-auto"
                color="cyan"
                elevation="3"
                max-width="calc(100% - 62px)"
              >
                <v-row>
                  <v-col cols="12">
                    <h4 class="ml-4">LO Affilication Status</h4>
                  </v-col>
                </v-row>
              </v-sheet>

              <v-card-text class="pt-0">
                <affiliation-document-list></affiliation-document-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import LocationInformationList from "./LocationInformationList.vue";
import BankInformationList from "./BankInformationList.vue";
import AffiliationDocumentList from "../affilication-document/AffiliationDocumentList.vue";
export default {
  mixins: [common],
  components: {
    BankInformationList,
    LocationInformationList,
    AffiliationDocumentList,
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  methods: {},
  mounted() {},
  beforeMount() {
    // this.refreshPageData();
  },
};
</script>
<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>